import React, { useState } from "react";
import { BillingTable, BillingTableContent, RowItem, TableContent } from "./style";
import { Heading4, Heading6 } from "components/text/heading/style";
import billing_theme from "style/theme_colors";
import { Body3 } from "components/text/body/style";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { Instalado } from "shared/models/fatura_response.model";
import { toMoney } from "utils/numberUtils";
import { toDate } from "utils/stringUtils";
import { NoContentTable } from "../../style";

const ViewFaturaInstalacaoTable: React.FC = () => {
  const viewFatura = useSelector((state: RootState) => state.view_fatura);

  return (
    <TableContent>
      <Heading4 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
        Equipamentos instalados
      </Heading4>
      {viewFatura.Objeto.Instalados.length == 0 && (
        <NoContentTable>
          <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
            Nenhuma item a ser mostrado!
          </Heading6>
        </NoContentTable>
      )}
      {viewFatura.Objeto.Instalados.length != 0 && (
        <BillingTableContent>
          <BillingTable>
            <thead>
              <HeadTable />
            </thead>
            <tbody>
              {viewFatura.Objeto.Instalados.map(el => (
                <ItemInstalacao key={el.ID} Instalado={el} />
              ))}
            </tbody>
          </BillingTable>
        </BillingTableContent>
      )}
    </TableContent>
  );
};
const HeadTable: React.FC = () => {
  return (
    <tr>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Numero contrato
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Placa
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Resumo Serviço
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Equipamento
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Mensalidade
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Descontos
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Valor Total
        </Heading6>
      </td>
    </tr>
  );
};
const ItemInstalacao: React.FC<{ Instalado: Instalado }> = ({ Instalado }) => {
  return (
    <RowItem>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {Instalado.NumeroContratoBilling}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {Instalado.Placa}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {Instalado.ResumoServicos}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {Instalado.Equipamento}
        </Body3>
      </td>

      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {toMoney(Instalado.Mensalidade)}
        </Body3>
      </td>

      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {toMoney(Instalado.Descontos)}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {toMoney(Instalado.ValorTotal)}
        </Body3>
      </td>
    </RowItem>
  );
};
export default ViewFaturaInstalacaoTable;
